import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { AvatarMenu, NavigationBar } from '@marketcast/ui-kit';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/auth';
import { Routing } from '@/pages/routing';

export const BasePage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <Box height="100vh">
      <Flex direction={'column'} height="100%">
        <Box width={'100%'}>
          <NavigationBar onLogoClick={() => navigate('/')}>
            <div />
            <AvatarMenu name={user?.name} ml="auto">
              {null}
            </AvatarMenu>
          </NavigationBar>
        </Box>
        <Flex flex={1} overflow="hidden">
          <Routing />
        </Flex>
      </Flex>
    </Box>
  );
};
